import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { IaddnewAssociations, Idropdown, IHome } from '../sidenav/helper';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { HomeService } from '../services/homeservice';
import { DynamicTabsService } from '../dynamic-tabs.service';
import { MatTabsModule } from '@angular/material/tabs';
import { RefreshDialogComponent } from '../dialogs/refresh-dialog/refresh-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { BodyComponent } from '../body/body.component';
const compare = (v1: string | number, v2: string | number) => (v1 < v2 ? -1 : v1 > v2 ? 1 : 0);
@Component({
  selector: 'app-association-details',
  templateUrl: './association-details.component.html',
  styleUrls: ['./association-details.component.css'],

})

export class AssociationDetailsComponent {
  @Input() id: number = 0;
  @Input() label: string = '';
  @Input() type: string = '';
  @Output() emitAssnId = new EventEmitter();
  @Output() openDetailTab = new EventEmitter();
  dwStates!: Idropdown[];
  details: IaddnewAssociations = new IaddnewAssociations();
  details1: IaddnewAssociations = new IaddnewAssociations();
  response: IaddnewAssociations = new IaddnewAssociations();
  masterPolicies!: IHome[];
  searchTerm: string = '';
  filteredData: IHome[] = [];
  sortingColumn: keyof IHome | '' = '';
  sortOrder: 'asc' | 'desc' = 'asc';
  isSearching: boolean = false;
  isLoading: boolean = false;
  dataSource!: MatTableDataSource<IHome>;
  totalItems: number = 0;
  currentPageIndex: number = 0;
  pageSize: number = 45;
  pageSizeOptions: number[] = [45, 90, 135];
  isHidePageSize: boolean = true;
  showFirstLastButtons = true;
  currentPage: number = 0;
    @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  columnsToDisplay = [
    'policyNumber',
    'policyType',
    'contractNumber',
    'policyStatus',
    'effectiveDate',
    'expirationDate',
    'premium',
    'notes',
    'created',
    'createdBy',
    'lastUpdated',
    'lastUpdatedBy',
  ]
  
  constructor(private router: Router, private service: HomeService, public dynamicTabService: DynamicTabsService,
    private dialog: MatDialog,
    private body: BodyComponent,
    private cdRef: ChangeDetectorRef) {
    this.dataSource = new MatTableDataSource<IHome>([]);
  }

  ngOnInit() {
    if (this.id > 0 && this.dynamicTabService.selectedTabData && this.dynamicTabService.selectedTabData.type == 'association' && this.dynamicTabService.selectedTabData.label == this.label) {
      this.getAssociationDetialsData(this.id);
      this.getPolicies(this.id);
      this.getDropdownStates();
          }
    // this.getAssociationDetialstableData();

    //save
    this.dynamicTabService.saveObv.subscribe(value => {
      if (value && this.dynamicTabService.selectedTabData && this.dynamicTabService.selectedTabData.label == this.label && this.dynamicTabService.selectedTabData.type == 'association')
        this.save();
    })

    //closeTab
    this.dynamicTabService.closeObv.subscribe(value => {
      if (value && this.dynamicTabService.closableTab && this.dynamicTabService.closableTab.type == 'association' && sessionStorage.getItem("closeBtn") == "true")
        this.closeTab();
    })

    //refresh
    this.dynamicTabService.refreshObv.subscribe(value => {
      if (value && this.dynamicTabService.selectedTabData && this.dynamicTabService.selectedTabData.label == this.label && this.dynamicTabService.selectedTabData.type == 'association')
        this.refresh();
    })
    this.loadTableData();

  }
ngAfterViewInit()
  {
    this.dataSource.paginator=this.paginator;
    this.checkRowsPerPage();
  }
  //event listener for searching
  @HostListener('document:keyup.enter',['$event'])
  handleEnterKey(event:KeyboardEvent)
  {
    if(event.key==='Enter')
    {
      this.search();
    }
  }
  //checking number of rows per page
  checkRowsPerPage() {
    if (this.paginator) {
      const rowsPerPage = this.paginator.pageSize;
      // console.log(`Number of rows per page:${rowsPerPage}`);
    }
  }
  loadTableData() {
        this.isLoading = true;
    this.getPolicies(this.id);
    
  }
  save() {
    if (this.details && this.details.accountID && this.details.accountID == this.dynamicTabService.selectedTabData.id) {
      if (sessionStorage.getItem('saveBtn') == 'true') {
        this.service.getAddnewAssociations(this.details).subscribe((res: IaddnewAssociations) => {
          // if (JSON.stringify(this.details) == JSON.stringify(this.details1)) {

          this.response = res;
          this.isLoading = true;
          this.details1 = Object.assign({}, this.response);
          this.details =this.response
          // const currentTab = this.dynamicTabService.tabs.find(tab => tab.label === this.dynamicTabService.selectedTab);

        // if (currentTab) {
        //   currentTab.closable = true;
        //   const currentIndex = this.dynamicTabService.tabs.indexOf(currentTab)
        //   this.dynamicTabService.removeTab(currentTab);
        //   const previousTab = this.dynamicTabService.tabs[currentIndex - 1];
        //   const nextTab = this.dynamicTabService.tabs[currentIndex];
        //   const actTab: number = this.dynamicTabService.tabs.filter(t => t.isActive == true).length;
        //   if (previousTab && actTab <= 0) {
        //     previousTab.isActive = true;
        //     this.body.openDetailTab(previousTab);

        //     // this.dynamicTabsService.tabs.forEach(tab => tab.isActive = true);
        //   }
        //   else if (nextTab && actTab <= 0) {
        //     nextTab.isActive = true;
        //     this.body.openDetailTab(nextTab);
        //   }
        //   else if (actTab == 0) {
        //     this.body.openDetailTab(actTab);
        //   }
        //   else {
        //     // If no previous tab, navigate to the default URL
        //     this.router.navigate(['/']);
        //   }
        // }

        }
        )
        setTimeout(() => {
          this.isLoading = false;
        }, 2000);

      }
      // else {
      //   this.dynamicTabService.closeTab(this.dynamicTabService.closableTab);
      // }

    }
  }
  refresh() {

    if (this.details && this.details.accountID && this.details.accountID == this.dynamicTabService.selectedTabData.id) {
      // this.getAssociationDetialsData(this.id);
      if (sessionStorage.getItem('refreshBtn') == 'true') {

        if (JSON.stringify(this.details) == JSON.stringify(this.details1)) {

          this.isLoading = true;
          this.getAssociationDetialsData(this.id);
          this.getPolicies(this.id);
          this.getDropdownStates();
          this.cdRef.detectChanges();
          this.clearSearch();
          // console.log("Association details refreshed");
          setTimeout(() => {
            this.isLoading = false;
          }, 2000);
        }
        else {
          const dialogRef = this.dialog.open(RefreshDialogComponent, {
            data: { message: 'refreshing?Refreshing' },
          });
          if (dialogRef.afterOpened())
            sessionStorage.setItem('refreshBtn', 'false')

          dialogRef.afterClosed().subscribe(result => {
            if (result === 'save') {
              sessionStorage.setItem('saveBtn', 'true');
              this.save();
            }
            else if (result === 'discard') {
              this.getAssociationDetialsData(this.id);
              this.getPolicies(this.id);
              this.getDropdownStates();
              this.cdRef.detectChanges();
              sessionStorage.setItem('refreshBtn', 'false');
              // console.log("Association details after changes refreshed");
            }
          });
        }
      }

    }
  }
  createTabsFromNavbarData(item: any): void {
    this.dynamicTabService.createTabsFromNavbarData(item);

  }

  getAssociationDetialsData(Id: number) {
    this.service.getAssociationDetials(Id).subscribe((res: any) => {
      this.details = res;
      this.details1 = Object.assign({}, this.details);
      // console.log(this.associationstable);

    })
  }
  getPolicies(id: number): void {
    this.service.getMasterPolicyData(id).subscribe((res: IHome[]) => {
      this.dataSource.data = res;
      this.masterPolicies = res;
      this.filteredData = this.masterPolicies;
      this.totalItems = this.filteredData.length;
      this.applyPagination();
      // this.isLoading = false;
    })
  }
  getDropdownStates() {
    this.service.getDropdownStates().subscribe((res: Idropdown[]) => {
      this.dwStates = res;
      this.isLoading = false;
      this.dynamicTabService.sortDropdownData(this.dwStates, item => item.name);
    })
  }
  openPolicy(policy: any) {
    this.openDetailTab.emit({ id: policy.id, label: policy.policyNumber + '-policy', type: 'policy' });
    // console.log(policy.id);
  }
  closeTab() {
    if (sessionStorage.getItem("closeBtn") == "true" && this.details && this.details.accountID && this.details.accountID == this.dynamicTabService.closableTab.id) {

      if (JSON.stringify(this.details) == JSON.stringify(this.details1)) {
        const currentTab = this.dynamicTabService.tabs.find(tab => tab.label === this.dynamicTabService.selectedTab);
        sessionStorage.setItem('closeBtn', 'false');
        if (currentTab) {
          // currentTab.closable = true;
          const currentIndex = this.dynamicTabService.tabs.indexOf(currentTab)
          if(currentTab.closable==true)
          this.dynamicTabService.removeTab(currentTab);
          if(this.dynamicTabService.closableTab)
          this.dynamicTabService.removeTab(this.dynamicTabService.closableTab)
          const previousTab = this.dynamicTabService.tabs[currentIndex - 1];
          const nextTab = this.dynamicTabService.tabs[currentIndex];
          const actTab: number = this.dynamicTabService.tabs.filter(t => t.isActive == true).length;
          if(this.dynamicTabService.tabs.find(tab => tab.label === this.dynamicTabService.selectedTabData.label)){
            this.dynamicTabService.selectedTabData.isActive=true;
            this.body.openDetailTab(this.dynamicTabService.selectedTabData);
          }
          else if (previousTab && actTab <= 0) {
            previousTab.isActive = true;
            this.body.openDetailTab(previousTab);

            // this.dynamicTabsService.tabs.forEach(tab => tab.isActive = true);
          }
          else if (nextTab && actTab <= 0) {
            nextTab.isActive = true;
            this.body.openDetailTab(nextTab);
          }
          else if (actTab == 0) {
            this.dynamicTabService.removeTab(currentTab);
          }
          // else {
          //   // If no previous tab, navigate to the default URL
          //   this.router.navigate(['/']);
          // }
        }     
      }
      else {
        this.dynamicTabService.tabs.filter(tab => tab.isActive = false);
        if(this.dynamicTabService.tabs.filter(tab=> tab.isActive!=true))
        this.dynamicTabService.closableTab.isActive = true;
        this.body.openDetailTab(this.dynamicTabService.closableTab);
        this.dynamicTabService.selectedTabData=this.dynamicTabService.closableTab;
        const dialogRef = this.dialog.open(RefreshDialogComponent, {
          data: { message: 'closing?Closing' },
        });

        if (dialogRef.afterOpened())
          sessionStorage.setItem('closeBtn', 'false');
        const i = sessionStorage.getItem('closeBtn');
        dialogRef.afterClosed().subscribe(result => {
          if (result === 'save') {
            sessionStorage.setItem('saveBtn', 'true');
            this.save();
            this.body.forceCloseTab(this.dynamicTabService.closableTab);
          }
          else
            if (result === 'discard') {
              this.body.forceCloseTab(this.dynamicTabService.closableTab);
              sessionStorage.setItem('closeBtn', 'false')
            }
        });
      }
    }
  }


  onPageChange(event: any): void {
    this.currentPageIndex = event.pageIndex;
    this.pageSize = 45;
    this.applyPagination();
  }

  applyPagination(): void {
    const startIndex = this.currentPageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.dataSource.data = this.filteredData.slice(startIndex, endIndex);
  }
  applyFilter(): void {
    this.pageSize = 45;
    this.currentPageIndex = 0;
    const searchValue = this.searchTerm.trim().toLowerCase();
    this.filteredData = this.masterPolicies.filter((item) => {
      const searchFields = [item.policyNumber, item.policyType, item.contractNumber,
      item.policyStatus, item.effectiveDate, item.expirationDate, item.premium, item.notes, item.created,
      item.createdBy, item.lastUpdated, item.lastUpdatedBy];
      return searchFields.some((field) => String(field).toLowerCase().includes(searchValue));
    });
    this.totalItems = this.filteredData.length;
    this.isSearching = searchValue != '';
    this.applyPagination();
  }

  performSearch() {
    this.search();
  }
  cancelSearch() {
    this.searchTerm = '';
    this.search();
  }
  search(): void {
    this.applyFilter();
  }

  clearSearch(): void {
    this.pageSize = 45;
    this.currentPageIndex = 0;
    this.searchTerm = '';
    this.isSearching = false;
    this.filteredData = this.masterPolicies;
    this.totalItems = this.masterPolicies.length;
    this.applyPagination();
  }

  getTotalPages(): number {
    return Math.ceil(this.masterPolicies.length / this.pageSize);
  }


  sortData(column: keyof IHome) {
    if (this.sortingColumn == column) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    }
    else {
      this.sortingColumn = column;
      this.sortOrder = 'asc';
    }
    this.masterPolicies.sort((a, b) => {
      const valueA = (a[column] || '').toString();
      const valueB = (b[column] || '').toString();

      if (valueA.toLowerCase() < valueB.toLowerCase()) {
        return this.sortOrder === 'asc' ? -1 : 1;
      }
      else if (valueA.toLowerCase() > valueB.toLowerCase()) {
        return this.sortOrder === 'asc' ? 1 : -1;
      }
      //Handle empty values
      if (valueA === '' && valueB === '') {
        return 0;
      } else if (valueA === '') {
        return -1;
      } else if (valueB === '') {
        return 1;
      }
      return 0;

    });
    this.applyPagination();
  }

}
